// Generated using typescript-generator version 1.25.322 on 2017-09-07 10:40:33.

import { ApiConfig, Route, Step, ChannelConfig, EntityTypes } from './cerebrum-core';
import {FlowType} from "./state/Flow";

export class FileNode {
  id: number;
  name: string;
  path?: string;
  children: FileNode[];
}

export class Review {
  reviewer: string;
  status: string;
}

export class StageRequest {
  message?: string;
  flowId?: string;
  flowType?: FlowType;
  flowName?: string;
  flowPath?: string;
  flow?: Map<String, Step>;
  apiMap?: Map<String, ApiConfig>;
  routeMap?: {};
  channelId?: number;
  channelConfig?: ChannelConfig;
  clientId?: string;
  channelIds?: Array<string>;
  shortcutKeywords?: ShortcutKeywordsRequest;
  routesToDelete?: Array<string>;
}

export class ChangeLog {
  author: string;
  message: string;
  date: Date;
  dateString?: string;
}

export class SubmissionApprovalRequest {
  submissionId: number;
  reviewerType: string;
  action?: SubmissionAction;
  submissionType: SubmissionType;
  flowPath?: string;
  flowId?: string;
}

export class SubmissionRequest {
  summary: string;
  fileName: string;
  flowPath?: string;
  entityId: string;
  entityType: string;
  submissionType?: SubmissionType;
}

export class Approvals {
  status: Status;
  submission: Submission;
}

export class Submission {
  id: number;
  clientId?: number;
  entityId?: number;
  submitter: string;
  summary: string;
  fileName: string;
  commitHash: string;
  state: SubmissionState;
  requiredInternalApprovals: number;
  requiredClientApprovals: number;
  totalRequiredApprovals: number;
  createdDate: any;
  cdcUpdateTimestamp: any;
  dateString?: string;
  flowPath?: string; // * only optional for backwards compatibility with Old UI and possibly malformed submission requests
  submissionType?: SubmissionType;

  get getSubmissionType() {
    return this.submissionType;
  }
}

export class Status {
  CLIENT: Client;
  INTERNAL: Internal;
  TOTAL: Total;
}

export class Client {
  approvedCount: number;
  required: number;
}

export class Internal {
  approvedCount: number;
  required: number;
}

export class Total {
  approvedCount: number;
  required: number;
}

export class SubmissionApproval {
  id?: number;
  submissionId: number;
  reviewer: string;
  reviewerType: string;
  email: string;
  action: SubmissionAction;
  createdDate?: any;
  updatedDate?: any;

  constructor(
    submissionId: number,
    reviewer: string,
    action: SubmissionAction,
    reviewerType: string,
    email: string
  ) {
    this.submissionId = submissionId;
    this.reviewer = reviewer;
    this.action = action;
    this.reviewerType = reviewerType;
    this.email = email;
  }

  dateString?: string;
}

export class Channels {
  id: string;
  description: string;
}

export class ChannelKeywords {
  keywords: string[];
}

export class KeywordConfig {
  flowName: string;
  step: string;

  constructor(flowName: string, step: string) {
    this.flowName = flowName;
    this.step = step;
  }
}

export class ShortcutKeywordsRequest {
  keywordConflictMessage: string;
  keywords: Object;
}

export type SubmissionState = 'APPROVED' | 'DECLINED' | 'PENDING';

export type SubmissionAction = 'APPROVE' | 'DECLINE' | 'DEPLOY';

export type SubmissionType = 'PROMOTE' | 'DELETE';
